(() => {
  if (window.huanengCertificateCarouselLoaded) return;
  window.huanengCertificateCarouselLoaded = true;

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-hn-cert-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialised === 'true') return;
      carousel.dataset.initialised = 'true';

      const track = carousel.querySelector('[data-hn-cert-track]');
      const previous = carousel.querySelector('[data-hn-cert-prev]');
      const next = carousel.querySelector('[data-hn-cert-next]');
      if (!track || !previous || !next) return;

      const cardStep = () => {
        const card = track.firstElementChild;
        const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      };

      const updateControls = () => {
        const end = track.scrollWidth - track.clientWidth - 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end;
      };

      const advance = () => {
        const end = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= end) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        }
      };

      let timer;
      const startAutoplay = () => {
        window.clearInterval(timer);
        timer = window.setInterval(advance, 2400);
      };
      const stopAutoplay = () => window.clearInterval(timer);

      previous.addEventListener('click', () => {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
        startAutoplay();
      });
      next.addEventListener('click', () => {
        advance();
        startAutoplay();
      });
      track.addEventListener('scroll', updateControls, { passive: true });
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);
      carousel.addEventListener('touchstart', stopAutoplay, { passive: true });
      carousel.addEventListener('touchend', startAutoplay, { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });
      updateControls();
      startAutoplay();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
